import { useNavigate } from "react-router-dom";
import useIsMobile from "../hooks/useIsMobile";
import addLine from "../imgs/add-line.svg";
import arrow from "../imgs/arrow-right-line.svg";
import { motion, AnimatePresence } from "framer-motion";

import "./Header.css";
import { openTalk, openDocument, openJoin } from "./FirstPage";
import logo from "../imgs/logo.svg";
import close from "../imgs/close.svg";
import arrowRightLine from "../imgs/arrow-right-line.svg";
import { useEffect, useState } from "react";

export const openWhitePaper = () => {
  window.open(
    " https://get.celer.app/brevis/BrevisWhitePaper_09271015.pdf",
    "_blank"
  );
};
export const openBlog = () => {
  window.open("https://blog.brevis.network/", "_blank");
};
export const openDoc = () => {
  window.open("https://docs.brevis.network/", "_blank");
};
export const openIncentra = () => {
  window.open("https://incentra.brevis.network/", "_blank");
};
export const openDiscord = () => {
  window.open("https://discord.com/invite/QTRkjKdZ6A", "_blank");
};
export const openExplorer = () => {
  window.open("https://explorer.brevis.network", "_blank");
};
export const openTwitter = () => {
  window.open("https://twitter.com/brevis_zk", "_blank");
};
export const openCareer = () => {
  window.open("https://jobs.ashbyhq.com/brevis-network", "_blank");
};
export const openIncentraDocs = () => {
  window.open("https://incentra-docs.brevis.network/", "_blank");
};
const Header = () => {
  const { isMobile } = useIsMobile();
  const history = useNavigate();
  const [open, setOpen] = useState(false);
  const [openCommunity, setOpenCommunity] = useState(false);

  const [visible, setVisible] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  const products = [
    { name: "Pico zkVM", link: "https://pico-docs.brevis.network/" },
    {
      name: "ZK Data Coprocessor",
      link: "https://coprocessor-docs.brevis.network/",
    },
    { name: "Incentra", link: "https://incentra-docs.brevis.network/" },
    {
      name: "ProverNet",
      link: "https://provernet-docs.brevis.network/index.html",
    },
    {
      name: "Brevis Vera",
      link: "https://vera.brevis.network",
    },
  ];
  const communitys = [
    { name: "X (Twitter)", link: "https://x.com/brevis_zk" },
    { name: "Discord", link: "https://discord.com/invite/QTRkjKdZ6A" },
  ];

  return isMobile ? (
    <div className="headerMobile">
      <img
        alt=""
        className="logo"
        src={logo}
        onClick={() => {
          history("/");
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 50);
        }}
      />
      <div
        className="headerMobileBtn"
        onClick={() => {
          setOpenModal(true);
          document.body.style.overflow = "hidden";
        }}
      >
        Menu
      </div>
      {openModal && (
        <div className="headerMobileModal">
          <div className="closeArea">
            <img
              alt=""
              className="closeIcon"
              src={close}
              onClick={() => {
                setOpenModal(false);
                document.body.style.overflow = "auto";
              }}
            />
          </div>
          <div className="headerMobileModalBody">
            <div className="modalTextTitle">PRODUCT</div>
            <div className="modalLine"></div>
            {products?.map((t) => {
              return (
                <div
                  key={t.name}
                  className="modalText"
                  onClick={() => {
                    window.open(t.link, "_blank");
                  }}
                >
                  {t.name}
                  <img src={arrow} alt="" />
                </div>
              );
            })}
            <div className="modalLine" style={{ marginTop: 24 }}></div>

            <div
              className="modalText"
              onClick={() => {
                openExplorer();
              }}
            >
              Explorer <img src={arrow} alt="" />
            </div>
            <div
              className="modalText"
              onClick={() => {
                navigate("/ecosystem");
                setOpenModal(false);
              }}
            >
              Ecosystem <img src={arrow} alt="" />
            </div>

            <div className="modalLine" style={{ marginTop: 24 }}></div>
            <div
              className="modalText"
              onClick={() => {
                openBlog();
              }}
            >
              Blog
              <img src={arrow} alt="" />
            </div>
            <div className="modalLine" style={{ marginTop: 24 }}></div>
            <div className="modalTextTitle">COMMUNITY</div>
            <div className="modalLine" style={{ marginTop: 8 }}></div>
            {communitys?.map((t) => {
              return (
                <div
                  key={t.name}
                  className="modalText"
                  onClick={() => {
                    window.open(t.link, "_blank");
                  }}
                >
                  {t.name}
                  <img src={arrow} alt="" />
                </div>
              );
            })}
            <div className="modalLine" style={{ marginTop: 24 }}></div>

            <div
              className="modalText"
              onClick={() => {
                openCareer();
              }}
            >
              Career
              <img src={arrow} alt="" />
            </div>
            <div className="modalBottom">
              <div className="modalLine" style={{ marginTop: 24 }}></div>

              <div
                className="modalText"
                onClick={() => {
                  openDocument();
                }}
              >
                Explore Documentation{" "}
                <img
                  alt=""
                  className="arrowRightLine"
                  src={arrowRightLine}
                  onClick={() => {}}
                />
              </div>
              <div
                className="modalText"
                onClick={() => {
                  openTalk();
                }}
              >
                Talk to our Team{" "}
                <img
                  alt=""
                  className="arrowRightLine"
                  src={arrowRightLine}
                  onClick={() => {}}
                />
              </div>
              <div
                className="modalText"
                onClick={() => {
                  openJoin();
                }}
              >
                Join our Community{" "}
                <img
                  alt=""
                  className="arrowRightLine"
                  src={arrowRightLine}
                  onClick={() => {}}
                />
              </div>
              <div style={{ height: 40 }}></div>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div
      className="header"
      style={{ transform: visible ? "translateY(0)" : "translateY(-130%)" }}
    >
      <div className="headerBar">
        <img
          alt=""
          className="logo"
          src={logo}
          style={{ width: 108, height: 34, cursor: "pointer" }}
          onClick={() => {
            history("/");
            setTimeout(() => {
              window.scrollTo(0, 0);
            }, 50);
          }}
        />
        <div className="headerContent">
          <div
            className="headerBtn"
            style={{ position: "relative" }}
            onMouseLeave={() => setOpen(false)}
            onMouseEnter={() => setOpen(true)}
          >
            Products
            <AnimatePresence>
              {open && (
                <motion.div
                  initial={{ opacity: 0, y: -5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -5 }}
                  transition={{ duration: 0.15 }}
                  className="headDrop"
                  style={{
                    top: 41,
                  }}
                >
                  {products.map((p) => (
                    <motion.a
                      key={p.name}
                      href={p.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{
                        backgroundColor: "rgba(43, 48, 59, 0.05)",
                      }}
                      className="headDropItem"
                    >
                      {p.name}
                    </motion.a>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div
            className="headerBtn"
            onClick={() => {
              openExplorer();
            }}
          >
            Explorer
          </div>
          <div
            className="headerBtn"
            onClick={() => {
              navigate("/ecosystem");
              setOpenModal(false);
            }}
          >
            Ecosystem
          </div>
          <div
            className="headerBtn"
            onClick={() => {
              openBlog();
            }}
          >
            Blog
          </div>
          <div
            className="headerBtn"
            onMouseLeave={() => setOpenCommunity(false)}
            onMouseEnter={() => setOpenCommunity(true)}
          >
            Community
            <img alt="" className="add_line" src={addLine} onClick={() => {}} />
            <AnimatePresence>
              {openCommunity && (
                <motion.div
                  initial={{ opacity: 0, y: -5 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -5 }}
                  transition={{ duration: 0.15 }}
                  className="headDrop"
                  style={{
                    top: 43,
                    minWidth: 150,
                  }}
                >
                  {communitys.map((p) => (
                    <motion.a
                      key={p.name}
                      href={p.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      whileHover={{
                        backgroundColor: "rgba(43, 48, 59, 0.05)",
                      }}
                      className="headDropItem"
                    >
                      {p.name}
                    </motion.a>
                  ))}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div
            className="headerBtn"
            style={{ marginRight: 0 }}
            onClick={() => {
              openCareer();
            }}
          >
            Career
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
